// extracted by mini-css-extract-plugin
export var alignCenter = "Typography-module--alignCenter--d31d6";
export var alignJustify = "Typography-module--alignJustify--840c7";
export var alignLeft = "Typography-module--alignLeft--ab345";
export var alignRight = "Typography-module--alignRight--1a769";
export var capitalize = "Typography-module--capitalize--09ebd";
export var caption = "Typography-module--caption--c829c";
export var h1 = "Typography-module--h1--78cbf";
export var h2 = "Typography-module--h2--6fb36";
export var h3 = "Typography-module--h3--84f5f";
export var h4 = "Typography-module--h4--87f30";
export var h5 = "Typography-module--h5--7a289";
export var h6 = "Typography-module--h6--81ab7";
export var label = "Typography-module--label--1b62f";
export var label2 = "Typography-module--label2--59a44";
export var lowercase = "Typography-module--lowercase--51f91";
export var overline = "Typography-module--overline--cf3c6";
export var subCaption = "Typography-module--subCaption--5a705";
export var subtitle = "Typography-module--subtitle--3eba9";
export var tooltip = "Typography-module--tooltip--ffd22";
export var transformNone = "Typography-module--transformNone--d3292";
export var typography = "Typography-module--typography--c0c5f";
export var uppercase = "Typography-module--uppercase--9c7fa";
export var weightBold = "Typography-module--weightBold--3ed65";
export var weightLight = "Typography-module--weightLight--9a5c9";
export var weightMedium = "Typography-module--weightMedium--6e3ed";
export var weightRegular = "Typography-module--weightRegular--6f076";